import React from "react";
import styles from "./index.module.scss";
import classNames from "classnames";

interface ListCardIconProps {
    variant?: "blue" | "green" | "red";
    children?: React.ReactNode;
    className?: string;
}

export function ListCardIcon({
    variant = "blue",
    className,
    children
}: ListCardIconProps) {
    return (
        <div className={classNames(className, styles.root, styles[variant])}>
            {children}
        </div>
    );
}
